import React from 'react'

import { User } from '../../models/User'
import { useUsers } from '../../state/entities'
import Slugs from './Slugs/Slugs'
import UserSlug from './UserSlug/UserSlug'

const render = (user: User) => <UserSlug key={user.uuid} user={user} />

export default React.memo(function UserSlugs({
  uuids,
  max,
  className,
}: {
  uuids: string[]
  max: number
  className?: string
}) {
  const { users } = useUsers(uuids.slice(0, max))
  return <Slugs items={users} max={max} total={uuids.length} render={render} className={className} />
})
